import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.1684 9.79986L6.39062 10.411V6.38375C6.38995 6.22343 6.3263 6.0698 6.2134 5.95597L2.2534 1.94097H11.7623L7.8084 5.95597C7.6955 6.0698 7.63186 6.22343 7.63118 6.38375L7.61285 11.1076L8.83507 11.7187V6.63431L12.8562 2.55208C13.017 2.3889 13.1089 2.17008 13.1128 1.94097V1.32986C13.1128 1.16778 13.0485 1.01235 12.9339 0.89774C12.8193 0.783135 12.6638 0.71875 12.5017 0.71875H1.50174C1.33966 0.71875 1.18422 0.783135 1.06962 0.89774C0.95501 1.01235 0.890625 1.16778 0.890625 1.32986V1.94097C0.894535 2.17008 0.986438 2.3889 1.14729 2.55208L5.1684 6.63431V9.79986Z" })
});
export default SvgFilter;
